export enum DataFormatsEnum {
	CURRENCY = 'EUR',
	DATE = 'dd/MM/yyyy, HH:mm',
}
